<template>
  <div class="OrcamentoCmo">
    <el-row style="padding:0px;">
      <el-col :xs="24" :sm="24" :md="20" :lg="20" :xl="20">
        <h3 style="padding:0px; margin-top:0px;margin-bottom:0px;">Custo Mão de Obra Painéis</h3>
      </el-col>
      <el-col :xs="24" :sm="24" :md="4" :lg="4" :xl="4">
        <el-button
          @click="addCmo()"
          size="mini"
          type="primary"
          icon="el-icon-circle-plus-outline"
        >Adicionar</el-button>
      </el-col>
    </el-row>

    <!-- DIALOG -->
    <el-dialog title="Encontrar Orçamento SGE" :visible.sync="dialogCmoVisible">
      <el-row type="flex" justify="left">
        <el-col :xs="24" :sm="24" :md="20" :lg="22" :xl="20">
          <el-form
            :label-position="labelPosition"
            :model="ruleForm"
            ref="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item label="Função" prop="funcao" class="tamanho_label">
              <el-input v-model="ruleForm.funcao"></el-input>
            </el-form-item>
            <el-row :gutter="10" justify="left">
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item label="Carga Horária" prop="carga_horaria">
                  <el-input
                    v-model="ruleForm.carga_horaria"
                    v-on:change="calculaTotal"
                    v-mask="['#,##', '##,##', '###,##', '#.###,##', '##.###,##', '###.###,##']"
                  >
                    <template slot="prepend">R$</template>
                  </el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item label="Horas Normais" prop="hora_normal">
                  <el-input
                    v-model.number="ruleForm.hora_normal"
                    v-on:blur="calculaTotal"
                    type="number"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item label="Hora Extra 50%" prop="hora_extra_50">
                  <el-input
                    v-model.number="ruleForm.hora_extra_50"
                    v-on:blur="calculaTotal"
                    type="number"
                  ></el-input>
                </el-form-item>
              </el-col>

              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item label="Hora Extra 100%" prop="hora_extra_100">
                  <el-input
                    v-model.number="ruleForm.hora_extra_100"
                    v-on:blur="calculaTotal"
                    type="number"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-row>
              <el-col :xs="24" :sm="24" :md="12" :lg="6" :xl="6">
                <el-form-item label="total" prop="total">
                  <el-input v-model="ruleForm.total" :disabled="true">
                    <template slot="prepend">R$</template>
                  </el-input>
                </el-form-item>
              </el-col>
            </el-row>

            <el-form-item>
              <el-button @click="handleAdd()" type="primary">Adicionar</el-button>
              <el-button @click="handleFechar()">Cancelar</el-button>
            </el-form-item>
          </el-form>
        </el-col>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
// function testee(){
//   console.lot('ddddd');
// }

export default {
  data() {
    return {
      labelPosition: "top",
      dialogCmoVisible: false,
      ruleForm: {
        funcao: "",
        carga_horaria: "",
        hora_normal: "",
        hora_extra_50: "",
        hora_extra_100: "",
        total: "",
      },
    };
  },
  methods: {
    addCmo() {
      this.dialogCmoVisible = true;
    },
    handleFechar() {
      this.$confirm("Tem certeza que deseja sair?", "Aviso", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning",
      })
        .then(() => {
          this.ruleForm.funcao = "";
          this.ruleForm.carga_horaria = "";
          this.ruleForm.hora_normal = "";
          this.ruleForm.hora_extra_50 = "";
          this.ruleForm.hora_extra_100 = "";
          this.ruleForm.total = "";
          this.dialogCmoVisible = false;
        })
        .catch(() => {
          this.dialogCmoVisible = true;
        });
    },
    handleAdd() {
      this.$emit("cmo-click", this.ruleForm);
      this.ruleForm.funcao = "";
      this.ruleForm.carga_horaria = "";
      this.ruleForm.hora_normal = "";
      this.ruleForm.hora_extra_50 = "";
      this.ruleForm.hora_extra_100 = "";
      this.ruleForm.total = "";
      this.dialogCmoVisible = false;
    },
    calculaTotal() {
      let he50 = 0;
      he50 = this.ruleForm.hora_extra_50 * 1.5;
      let he100 = 0;
      he100 = this.ruleForm.hora_extra_100 * 2;

      let ch = this.ruleForm.carga_horaria;
      ch = ch.replace(".", "");
      ch = ch.replace(",", ".");

      this.ruleForm.total =
        parseFloat(ch) *
        (parseFloat(this.ruleForm.hora_normal) +
          parseFloat(he50) +
          parseFloat(he100));
      if (isNaN(this.ruleForm.total)) {
        this.ruleForm.total = "";
      } else {
        this.ruleForm.total = this.ruleForm.total.toFixed(2);
      }
    },
  },
};
</script>
<style scoped>
</style>